import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { FontAwesome } from '../../FontAwesome';

import './AttachFilesButton.scss';

export class AttachFilesButton extends React.PureComponent {
  static propTypes = {
    attachLabel: PropTypes.string,
    // TODO: extend functionality if needed
    // multipleFiles: PropTypes.bool,

    onChange: PropTypes.func,
  };

  static defaultProps = {
    attachLabel: 'Attach a file',
    // multipleFiles: false,

    onChange: (files) => {}, // eslint-disable-line no-unused-vars
  };

  constructor(props) {
    super(props);

    this.fileInput = null;
    this.attachmentInputId = _.uniqueId('attachment-input-');
  }

  onAttachClick = () => {
    if (!this.fileInput) {
      return;
    }

    this.fileInput.click();
  };

  onFileChange = (event) => {
    const { onChange } = this.props;
    const { files } = event.currentTarget;
    const filesList = [];

    if (files.length > 0) {
      for (let i = 0; i < files.length; i += 1) {
        filesList.push(files[i]);
      }
    }

    onChange(filesList);
  };

  refFileInput = (el) => {
    this.fileInput = el;
  };

  render() {
    const { attachLabel } = this.props;

    return (
      <attach-files-button>
        <span className="attach-label">
          <FontAwesome name="paperclip" />
          <button
            type="button"
            className="btn-link"
            onClick={this.onAttachClick}
          >
            {attachLabel}
          </button>
        </span>

        <div className="attachments-list">
          <label
            className="attachments-input-label"
            htmlFor={this.attachmentInputId}
          >
            {attachLabel}
          </label>
          <input
            type="file"
            ref={this.refFileInput}
            className="attachment"
            onChange={this.onFileChange}
            tabIndex="-1"
            id={this.attachmentInputId}
          />
        </div>
      </attach-files-button>
    );
  }
}
